import { Paper, Grid, Typography } from "@mui/material";
import { useEndCustomerPaid } from "Context/EndCustomerPaid";
import { useEffect, useState } from "react";

const NumberFormatter = (number) => {
  const formattedNumber = number ? number.toLocaleString("fr-FR") : 0;

  return formattedNumber;
};

const InvoiceInfoBox = () => {
  const {
    totalConnectedAmount,
    totalAmountLeft,
    totalNrInvoices,
    totalNrConnectedInvoices,
    totalAmount,
  } = useEndCustomerPaid();

  return (
    <Paper sx={{ padding: "10px", minWidth: "250px" }} elevation={4}>
      <Grid item container justifyContent={"space-between"}>
        <Grid item>
          <Typography
            fontWeight={600}
          >{`Totalt (${totalNrInvoices} st):`}</Typography>
        </Grid>
        <Grid item>
          <Typography>{`${NumberFormatter(totalAmount)} kr`}</Typography>
        </Grid>
      </Grid>

      <Grid item container justifyContent={"space-between"}>
        <Grid item>
          <Typography>{`Kopplat (${totalNrConnectedInvoices} st):`}</Typography>
        </Grid>
        <Grid item>
          <Typography>{`${NumberFormatter(
            totalConnectedAmount
          )} kr`}</Typography>
        </Grid>
      </Grid>
      <Grid item container justifyContent={"space-between"}>
        <Grid item>
          <Typography>{`Ej kopplat (${
            totalNrInvoices - totalNrConnectedInvoices
          } st):`}</Typography>
        </Grid>
        <Grid item>
          <Typography>{`${NumberFormatter(totalAmountLeft)} kr`}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default InvoiceInfoBox;
